import { axios } from '@pukka/auth';
import { MOKA_GOAUTH_SERVICE } from '@pukka/common/constants';

import { PaymentsModel } from '../models';

const MOKA_SERVICE_PAYMENT = `${MOKA_GOAUTH_SERVICE}/payment`;

const PAYMENT_METHODS_URL = `${MOKA_SERVICE_PAYMENT}/v1/payment-methods`;

const PAYMENT_ACTIVATION_URL = `${MOKA_SERVICE_PAYMENT}/v1/activation-request/`;

async function getAllEWalletPaymentMethods(): Promise<PaymentsModel.EWalletList> {
  const { data } = await axios.get(PAYMENT_METHODS_URL);

  return data;
}

async function activatePaymentMethod(payload: PaymentsModel.ActivationRequestPayload) {
  const { data } = await axios.post(PAYMENT_ACTIVATION_URL, payload);

  return data;
}

export { PAYMENT_METHODS_URL, PAYMENT_ACTIVATION_URL, getAllEWalletPaymentMethods, activatePaymentMethod };
